export  function eventSlider() {
    const sliderSelector = document.querySelectorAll(".event-slider");

    if (sliderSelector.length) {
        sliderSelector.forEach(slider => {

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 20,
                resistanceRatio: 0,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true,
                    hide: false,
                    dragSize: "40px",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 2.6,
                        spaceBetween: 30,
                    },
                    1800: {
                        slidesPerView: 2.7,
                    },
                },
                on:{
                    progress: function() {
                        $(slider)[`${!this.progress ? 'add' : 'remove'}Class`]('isFirst');
                        $(slider)[`${this.progress>=1 ? 'add' : 'remove'}Class`]('isLast');

                        let scrollbarLine = $(slider).find('.scrollbar-line');
                        let value = Math.abs(this.progress) * 100 + '%';
                        scrollbarLine.css('clip-path', 'polygon(0 0, ' + value + ' 0, ' + value + ' 100%, 0 100%)');
                    }
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/eventSlider.js